import {
    Task,
    Worker,
    WorkerFactory
} from "@tenera/upload_workers";

import AttachmentUploadRequest from "../request/AttachmentUploadRequest";
import { AttachmentUploadStatus } from "../status/AttachmentUploadStatus";
import AttachmentUploadWorker from "./AttachmentUploadWorker";
import DataStoreAttachmentRecordDAOFactory from '../../record/datastore/DataStoreAttachmentRecordDAOFactory';
import { GraphQLAttachmentRecordDAOFactory } from "../../record/graphql/GraphQLAttachmentRecordDAOFactory";
import { LocalForageAttachmentUploadStatusDAOFactory } from '../status/LocalForageAttachmentUploadStatusDAOFactory';
import { QueryClientManager } from '../../../query/QueryClientManager';
import { S3ImageAttachmentContentDAOFactory } from "../../content/s3/S3AttachmentContentDAOFactory";

export default class AttachmentUploadWorkerFactory implements WorkerFactory<Task<AttachmentUploadRequest, AttachmentUploadStatus>, void> {
    public createWorker(
        attachmentUploadRequest: Task<AttachmentUploadRequest, AttachmentUploadStatus>
    ): Worker<Task<AttachmentUploadRequest, AttachmentUploadStatus>, void> {
        return new AttachmentUploadWorker(
            attachmentUploadRequest,
            S3ImageAttachmentContentDAOFactory.getInstance(),
            DataStoreAttachmentRecordDAOFactory.getInstance(),
            GraphQLAttachmentRecordDAOFactory.getInstance(),
            LocalForageAttachmentUploadStatusDAOFactory.getInstance(),
            QueryClientManager.getInstance()
        );
    }
}